
import React, { useRef } from 'react'
import styled from '@emotion/styled'
import FormHeader from '../../components/FormHeader'
import FormController from '../../components/form-controller/form-controller'

export default function Page() {
  const headerRef = useRef(null)

  return (
    <ContactContainer>
      <FormHeader
        ref={headerRef}
        title="Elevate your event with beauty on call"
        content="Spa night for four? Brand activation for four thousand? We've got you covered with customizable glam services for any event. Fill out the details below and a member of our concierge booking team will be in touch with next steps."
        redirect='/events/contact'
      />
      <FormController formName="event" headerRef={headerRef} />
    </ContactContainer>
  )
}

const ContactContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100vw;
  box-sizing: border-box;
`
